export default __webpack_public_path__ + "static/media/inscription-grenoble.1fe447f6.jpg";